module.exports = __webpack_public_path__ + "static/the-oxford-history-of-britain-66a1f30f580243cc720a1aae2dc51e55.jpg";